<script>
  import { Doughnut } from "svelte-chartjs";
  import { Col } from "sveltestrap";
  import { DoughnutChart } from "../../../utils/Constant/Constant";
  import Card from "../../Core/Card.svelte";
  import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    ArcElement,
    CategoryScale,
  } from "chart.js";
  import {
    DoughnutData,
    DoughnutOption,
  } from "../../../Data/Chart/Charts/ChartJs";

  ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale);
</script>

<Col xl="6" md="12" class="box-col-12">
  <Card
    headerTitle={DoughnutChart}
    cardHeaderprops="pb-0"
    cardBodyprops="chart-block"
  >
    <div slot="contentbody">
      <Doughnut
        data={DoughnutData}
        options={DoughnutOption}
        width={730}
        height={365}
      />
    </div>
  </Card>
</Col>
